export default function getMaxPossiblePrize(jogo, numOfBalls) {
  if (!jogo) {
    return 0;
  }

  const numTotalPremioMaximo = jogo.objTipoJogo.numTotalPremioMaximo;

  if (!jogo.lstTamanhoFixo || jogo.lstTamanhoFixo.length <= 0) {
    return numTotalPremioMaximo || 0;
  }

  const item = numOfBalls
    ? jogo.lstTamanhoFixo.find((obj) => obj.tnyTamanho / 2 === numOfBalls)
    : []
        .concat(jogo.lstTamanhoFixo)
        .sort((a, b) => b.tnyTamanho - a.tnyTamanho)[0];

  if (!item.lstPagoQtdAcertos || item.lstPagoQtdAcertos.length <= 0) {
    return numTotalPremioMaximo || 0;
  }

  const numValorMaximoPremioPago = item.lstPagoQtdAcertos.reduce(
    (premio, item) =>
      item.numValorMaximoPremioPago > premio
        ? item.numValorMaximoPremioPago
        : premio,
    0
  );

  if (!numValorMaximoPremioPago) {
    return numTotalPremioMaximo || 0;
  }

  if (!numTotalPremioMaximo) {
    return numValorMaximoPremioPago || 0;
  }

  const maxPrize =
    numValorMaximoPremioPago > numTotalPremioMaximo
      ? numTotalPremioMaximo
      : numValorMaximoPremioPago;

  return maxPrize || 0;
}



// WEBPACK FOOTER //
// ./src/newDesign/utils/getPremioMaximo.js